'use strict';
import { addBrowserClasses } from './modules/_utils';
import './modules/_nav';
import { gsap } from "gsap";


document.addEventListener('DOMContentLoaded', function() {



	document.getElementsByClassName('no-js')[0].classList.remove('no-js');

	// Common functions
	addBrowserClasses();



	gsap.to(".hero", {
		autoAlpha: 1,
    delay: 0.1,
    duration: 0,
	})

gsap.from(".hero .col:first-of-type",
  { x: -100,
    delay: 1,
    opacity: 0,
    duration: 1,
    // ease: 'circ.in'
  });
gsap.from(".hero .col:last-of-type",
  { x: 100,
    delay: 1.25,
    opacity: 0,
    duration: 1,
    // ease: 'circ.in'
  });



// Open/close nav
// -----------------------------------------------------------
const menuBtn = document.getElementById('mobile-menu-btn');
const nav = document.getElementById('main-nav');

const toggleMenu = () => {
  nav.classList.toggle("open");

  // js implementation of jQuery slideToggle()
  nav.style.height = '0px';
  nav.addEventListener('transitioned', () => {
    nav.classList.remove('open');
  })

  if (nav.classList.contains('open')) {
    nav.style.height = 'auto';

    let height = nav.clientHeight + 'px';
    nav.style.height = '0px';

    setTimeout(() => {
      nav.style.height = height;
    }, 0);
  }

}

const closeMenu = () => {
  nav.classList.remove("open");

  if (!nav.classList.contains('open')) {
    nav.style.height = '0px';
  }
}

document.addEventListener("keyup", (e) => {
  if (e.key === "Escape") closeMenu();
});


const mq = window.matchMedia("screen and (min-width: 768px)");

mq.addEventListener("change", (event) => {
  if (event.matches) closeMenu();
  console.log(mq.matches);
})

menuBtn.addEventListener("click", toggleMenu);



// Sticky nav
// -----------------------------------------------------------

/*
const mainHeader = document.querySelector('.main-header');
let navPos = mainHeader.offsetTop;

window.addEventListener('scroll', () => {
  mainHeader.classList.add('fixed');
  if (document.scrollingElement.scrollTop <= navPos) {
    mainHeader.classList.remove('fixed');
  }
});

*/


// Scroll to top
// -----------------------------------------------------------
const scrollUp = document.querySelector('.scroll-up');

window.addEventListener('scroll', () => {
  scrollUp.classList.remove('show');
  if (window.scrollY > 500) {
    scrollUp.classList.add('show');
  }
})

scrollUp.addEventListener('click', () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
})



// Open option value in new tab
// -----------------------------------------------------------
const dropdowns = document.querySelectorAll('.select-cta');
const buttons = document.querySelectorAll('.cta-btn');

const populateHrefFromDropdown = (dropdown, button) => {
	dropdown.addEventListener('change', (event) => {
		button.href = event.target.value;
	});
}

dropdowns.forEach((dropdown, index) => {
  const correspondingButton = buttons[index];
	buttons[index].addEventListener('click', (event) => {
		if (correspondingButton.href !== dropdown.value) {
			event.preventDefault();
			alert('Please Select a Field of Expertise.');
		}
	});
  populateHrefFromDropdown(dropdown, correspondingButton);
});




});
